import { ContractType } from "domain/contract";
import Merchant from "domain/merchant";
import { ProducerAccount } from "features/settings/producers/producerAccount";

export default class LoggedInUser {
    internalId: string = "";
    name: string = "";
    email: string = "";
    merchants: Merchant[];
    activeMerchant: Merchant;
    type: UserType;
    identityType: IdentityType;
    userConfiguration: UserConfiguration = null;
    accounts: string[];
    customerAccounts: ProducerAccount[];
}

export enum UserType {
    System = -1,
    ApiKey = 0,
    Trader = 1,
    Customer = 2,
    SystemUser = 3
}

export enum IdentityType {
    Development = 1,
    Broker = 2,
    Customer = 3
}

export class UserConfiguration {
    maxOfferQuantity: number;
    canMakeOffer: boolean;
    canBuy: boolean;
    canSell: boolean;
    allowedContractTypes: ContractType[] = [];
}